// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import IconLargeArrowDown from "@conklin/XDL/Icons/IconLargeArrowDown";
import { xBaseTheme } from "@conklin/XDL/types";
import { color } from "@conklin/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import SelectPresentationPropsDefault from "@insite/mobius/Select/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...SelectPresentationPropsDefault,
        iconProps: {
            src: IconLargeArrowDown,
            size: 8,
            color: "common.ui5",
        },
        css: css`
            ~ ${IconWrapper} {
                justify-content: flex-end;
                width: auto;
            }

            &:hover ~ ${IconWrapper} {
                color: ${color("common.ui9")};
            }

            &&[aria-expanded="true"] ~ ${IconWrapper} {
                transform: rotate(180deg);
            }
        `,
    },
} as xBaseTheme["select"];
